import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { ChargingStateTranslatePipe } from '../../main/translate/charging-state-translate.pipe';
import { ChargerError, ChargerOverview } from '../../models';
import { ChargerSettingsService } from '../charger-settings.service';
import { ChargersService } from '../chargers.service';


@Component({
	selector: 'app-charger-status',
	imports: [MatListModule, MatProgressSpinnerModule, MatCardModule, MatIconModule, CommonModule, ChargingStateTranslatePipe],
	templateUrl: './charger-status.component.html',
	styleUrl: './charger-status.component.scss'
})
export class ChargerStatusComponent implements OnInit {
	chargerId!: string;
	chargerOverview = signal<ChargerOverview | null>(null);
	chargerOverviewLoaded = signal<boolean>(false);

	private route = inject(ActivatedRoute);
	private router = inject(Router);
	private chargersService = inject(ChargersService);
	private snackBar = inject(MatSnackBar);
	private chargerSettingsService = inject(ChargerSettingsService);

	constructor() { }

	ngOnInit() {
		this.chargerId = this.route.parent?.snapshot.paramMap.get('id') ?? '';
		const isValid = /^[PD]\d{14}$/.test(this.chargerId);
		if (!isValid) {
			this.router.navigate(['/404']);
		}

		this.chargersService.getChargerOverview(this.chargerId).subscribe((charger) => {
			console.log('getChargerOverview():', charger);
			this.chargerOverview.set(charger)
			this.chargerOverviewLoaded.set(true);
		});

	}


	getError(errorCode: number): ChargerError {
		switch (errorCode) {
			case 2:
				return {
					number: '111',
					description: $localize`:@@SensorboxMainSubCommunicationError:Sensorbox and/or main/sub communication error`
				};
			case 3:
				return {
					number: '102',
					description: $localize`:@@TemperatureTooHigh:Temperature too high`
				};
			case 4:
				return {
					number: '100',
					description: $localize`:@@ControlPilotError:Control Pilot (CP) error`
				};
			case 5:
				return {
					number: '101',
					description: $localize`:@@EarthLeakageDetected:Earth leakage detected`
				};
			case 6:
				return {
					number: '113',
					description: $localize`:@@PenFault:PEN fault`
				};
			default:
				return { number: '', description: '' };
		}
	}


	startCharge() {
		console.log('startCharge()');
		this.chargeCommand('start-charge', {startCommandParameters: {}}).subscribe();
	}

	stopCharge() {
		console.log('stopCharge()');
		this.chargeCommand('stop-charge').subscribe();
	}

	chargeCommand(commandId: string, parameters?: object): Observable<boolean> {
		return this.chargersService.putChargerCommand(this.chargerId, commandId, parameters).pipe(
			map(result => {
				return this.chargerSettingsService.openSnackbar(this.snackBar, result.success, result.errorMessage, $localize`:@@Command:Command`);
			}),
			catchError(err => {
				return of(this.chargerSettingsService.openSnackbar(this.snackBar, false, err.message, $localize`:@@Command:Command`));
			})			
		);

	}	
}
